module.exports = {
	"v": "5.0.5",
	"fr": 30,
	"ip": 0,
	"op": 90,
	"w": 640,
	"h": 1096,
	"nm": "personalize-animation",
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 640,
			"h": 1096,
			"u": "pages/media-publishing/animations/personalize/images/",
			"p": "img_0.png"
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Bar Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-81.992,
											0
										],
										[
											-36.038,
											-67.802
										]
									],
									"o": [
										[
											36.099,
											-67.604
										],
										[
											82.139,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-189.436,
											56.622
										],
										[
											-0.098,
											-56.985
										],
										[
											189.435,
											56.985
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.277999997606,
									0.556999954523,
									0.902000038297,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									320.597,
									178.985
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.667
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"n": [
									"0p667_1_0p333_0"
								],
								"t": 15,
								"s": [
									0
								],
								"e": [
									100
								]
							},
							{
								"t": 45
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Devices Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 0,
							"s": [
								20
							],
							"e": [
								20
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 18,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 25
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.253,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.253
										],
										[
											-1.252,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.253
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.252,
											0
										],
										[
											0,
											-1.253
										],
										[
											0,
											0
										],
										[
											1.253,
											0
										],
										[
											0,
											1.253
										]
									],
									"v": [
										[
											9.734,
											2.269
										],
										[
											-9.735,
											2.269
										],
										[
											-12.003,
											0
										],
										[
											-9.735,
											-2.269
										],
										[
											9.734,
											-2.269
										],
										[
											12.003,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-94.575,
													953.701
												],
												[
													545.425,
													953.701
												],
												[
													545.425,
													-142.299
												],
												[
													-94.575,
													-142.299
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-94.575,
													-142.299
												],
												[
													545.425,
													-142.299
												],
												[
													545.425,
													953.701
												],
												[
													-94.575,
													953.701
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									94.575,
									142.299
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											4.975,
											-2.613
										],
										[
											-4.975,
											-2.613
										],
										[
											-4.975,
											2.613
										],
										[
											4.975,
											2.613
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											2.576,
											0.214
										],
										[
											-2.576,
											0.214
										],
										[
											-2.576,
											-0.214
										],
										[
											2.576,
											-0.214
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-94.575,
													958.304
												],
												[
													545.425,
													958.304
												],
												[
													545.425,
													-137.696
												],
												[
													-94.575,
													-137.696
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-94.575,
													-137.696
												],
												[
													545.425,
													-137.696
												],
												[
													545.425,
													958.304
												],
												[
													-94.575,
													958.304
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									94.575,
									137.696
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 6,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.583,
											0
										],
										[
											0,
											0.584
										],
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										]
									],
									"o": [
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										],
										[
											-0.583,
											0
										],
										[
											0,
											0.584
										]
									],
									"v": [
										[
											-0.001,
											1.057
										],
										[
											1.058,
											0
										],
										[
											-0.001,
											-1.057
										],
										[
											-1.058,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-121.164,
													954.368
												],
												[
													518.836,
													954.368
												],
												[
													518.836,
													-141.632
												],
												[
													-121.164,
													-141.632
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-121.164,
													-141.632
												],
												[
													518.836,
													-141.632
												],
												[
													518.836,
													954.368
												],
												[
													-121.164,
													954.368
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									121.164,
									141.632
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 4,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.583,
											0
										],
										[
											0,
											0.585
										],
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										]
									],
									"o": [
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										],
										[
											-0.583,
											0
										],
										[
											0,
											0.585
										]
									],
									"v": [
										[
											-0.001,
											1.057
										],
										[
											1.058,
											0
										],
										[
											-0.001,
											-1.057
										],
										[
											-1.058,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-95.43,
													996.03
												],
												[
													544.57,
													996.03
												],
												[
													544.57,
													-99.97
												],
												[
													-95.43,
													-99.97
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-95.43,
													-99.97
												],
												[
													544.57,
													-99.97
												],
												[
													544.57,
													996.03
												],
												[
													-95.43,
													996.03
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									95.43,
									99.97
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 4,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.19
										],
										[
											0,
											0
										],
										[
											-2.209,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.209,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.19
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-24.637,
											-14.782
										],
										[
											-1.991,
											-14.782
										],
										[
											-1.991,
											-18.882
										],
										[
											-24.757,
											-18.882
										],
										[
											-28.737,
											-14.9
										],
										[
											-28.737,
											14.9
										],
										[
											-24.757,
											18.882
										],
										[
											17.969,
											18.882
										],
										[
											17.969,
											14.761
										],
										[
											-24.637,
											14.761
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.209,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.19
										]
									],
									"v": [
										[
											24.757,
											-18.882
										],
										[
											1.99,
											-18.882
										],
										[
											1.99,
											-14.782
										],
										[
											24.637,
											-14.782
										],
										[
											24.637,
											-6.142
										],
										[
											28.737,
											-6.142
										],
										[
											28.737,
											-14.9
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-95.437,
													979.203
												],
												[
													544.563,
													979.203
												],
												[
													544.563,
													-116.797
												],
												[
													-95.437,
													-116.797
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-95.437,
													-116.797
												],
												[
													544.563,
													-116.797
												],
												[
													544.563,
													979.203
												],
												[
													-95.437,
													979.203
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									95.437,
									116.797
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 6,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.781,
											1.503
										],
										[
											-3.781,
											1.503
										],
										[
											-3.781,
											-1.503
										],
										[
											3.781,
											-1.503
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-126.94,
													955.792
												],
												[
													513.06,
													955.792
												],
												[
													513.06,
													-140.208
												],
												[
													-126.94,
													-140.208
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-126.94,
													-140.208
												],
												[
													513.06,
													-140.208
												],
												[
													513.06,
													955.792
												],
												[
													-126.94,
													955.792
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									126.94,
									140.208
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 4,
					"cix": 2,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.622,
											1.503
										],
										[
											-3.622,
											1.503
										],
										[
											-3.622,
											-1.503
										],
										[
											3.622,
											-1.503
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-115.556,
													955.792
												],
												[
													524.444,
													955.792
												],
												[
													524.444,
													-140.208
												],
												[
													-115.556,
													-140.208
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-115.556,
													-140.208
												],
												[
													524.444,
													-140.208
												],
												[
													524.444,
													955.792
												],
												[
													-115.556,
													955.792
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									115.556,
									140.208
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 4,
					"cix": 2,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.433,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.453
										],
										[
											0,
											0
										],
										[
											-1.453,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.453
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.453,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.453
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.433,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.453
										]
									],
									"v": [
										[
											9.134,
											-18.942
										],
										[
											-9.115,
											-18.942
										],
										[
											-11.741,
											-16.314
										],
										[
											-11.741,
											16.314
										],
										[
											-9.115,
											18.942
										],
										[
											-1.991,
											18.942
										],
										[
											-1.991,
											14.96
										],
										[
											-7.762,
											14.96
										],
										[
											-7.762,
											-14.961
										],
										[
											7.76,
											-14.961
										],
										[
											7.76,
											14.96
										],
										[
											1.989,
											14.96
										],
										[
											1.989,
											18.942
										],
										[
											9.134,
											18.942
										],
										[
											11.741,
											16.314
										],
										[
											11.741,
											-16.314
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-121.169,
													970.384
												],
												[
													518.831,
													970.384
												],
												[
													518.831,
													-125.616
												],
												[
													-121.169,
													-125.616
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-121.169,
													-125.616
												],
												[
													518.831,
													-125.616
												],
												[
													518.831,
													970.384
												],
												[
													-121.169,
													970.384
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									121.169,
									125.616
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 4,
					"cix": 2,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Social Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 0,
							"s": [
								20
							],
							"e": [
								20
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 28,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 33
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.296,
											0
										],
										[
											0,
											-3.032
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.469,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-2.703,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.025
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.325,
											-0.044
										]
									],
									"v": [
										[
											2.44,
											-9.964
										],
										[
											-2.114,
											-5.28
										],
										[
											-2.114,
											-2.668
										],
										[
											-5.172,
											-2.668
										],
										[
											-5.172,
											0.874
										],
										[
											-2.114,
											0.874
										],
										[
											-2.114,
											9.964
										],
										[
											1.543,
											9.964
										],
										[
											1.543,
											0.874
										],
										[
											4.592,
											0.874
										],
										[
											5.049,
											-2.668
										],
										[
											1.543,
											-2.668
										],
										[
											1.543,
											-4.93
										],
										[
											3.297,
											-6.654
										],
										[
											5.173,
											-6.655
										],
										[
											5.173,
											-9.823
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-343.299,
													1062.11
												],
												[
													296.701,
													1062.11
												],
												[
													296.701,
													-33.89
												],
												[
													-343.299,
													-33.89
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-343.299,
													-33.89
												],
												[
													296.701,
													-33.89
												],
												[
													296.701,
													1062.11
												],
												[
													-343.299,
													1062.11
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									343.299,
									33.89
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											4.04,
											-2.688
										],
										[
											2.269,
											-0.299
										],
										[
											0.696,
											0
										],
										[
											0,
											8.261
										],
										[
											-8.259,
											0
										],
										[
											-0.676,
											-0.119
										],
										[
											-1.831,
											-1.254
										],
										[
											0,
											-5.196
										]
									],
									"o": [
										[
											-1.831,
											1.234
										],
										[
											-0.677,
											0.119
										],
										[
											-8.259,
											0
										],
										[
											0,
											-8.262
										],
										[
											0.696,
											0
										],
										[
											2.289,
											0.299
										],
										[
											4.04,
											2.668
										],
										[
											0,
											5.196
										]
									],
									"v": [
										[
											8.289,
											12.472
										],
										[
											2.079,
											14.821
										],
										[
											0.01,
											14.98
										],
										[
											-14.975,
											0.01
										],
										[
											0.01,
											-14.98
										],
										[
											2.06,
											-14.821
										],
										[
											8.289,
											-12.452
										],
										[
											14.975,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											8.418,
											2.15
										],
										[
											1.671,
											0
										],
										[
											0.458,
											-0.04
										],
										[
											0,
											-10.312
										],
										[
											-10.149,
											-0.696
										],
										[
											-0.458,
											0
										],
										[
											-1.553,
											0.398
										],
										[
											0,
											9.098
										]
									],
									"o": [
										[
											-1.553,
											-0.398
										],
										[
											-0.478,
											0
										],
										[
											-10.129,
											0.697
										],
										[
											0,
											10.312
										],
										[
											0.458,
											0.04
										],
										[
											1.671,
											0
										],
										[
											8.418,
											-2.15
										],
										[
											0,
											-9.118
										]
									],
									"v": [
										[
											4.866,
											-18.902
										],
										[
											0.01,
											-19.519
										],
										[
											-1.384,
											-19.459
										],
										[
											-19.513,
											0.01
										],
										[
											-1.363,
											19.459
										],
										[
											0.01,
											19.519
										],
										[
											4.866,
											18.902
										],
										[
											19.513,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-343.291,
													1062.12
												],
												[
													296.709,
													1062.12
												],
												[
													296.709,
													-33.88
												],
												[
													-343.291,
													-33.88
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-343.291,
													-33.88
												],
												[
													296.709,
													-33.88
												],
												[
													296.709,
													1062.12
												],
												[
													-343.291,
													1062.12
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									343.291,
									33.88
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 6,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											8.259,
											0
										],
										[
											0.676,
											0.119
										],
										[
											1.831,
											1.214
										],
										[
											0,
											5.196
										],
										[
											-4.02,
											2.687
										],
										[
											-2.269,
											0.299
										],
										[
											-0.696,
											0
										],
										[
											0,
											-8.262
										]
									],
									"o": [
										[
											-0.716,
											0
										],
										[
											-2.269,
											-0.299
										],
										[
											-4.02,
											-2.688
										],
										[
											0,
											-5.196
										],
										[
											1.831,
											-1.235
										],
										[
											0.676,
											-0.119
										],
										[
											8.259,
											0
										],
										[
											0,
											8.261
										]
									],
									"v": [
										[
											-0.01,
											14.98
										],
										[
											-2.099,
											14.822
										],
										[
											-8.288,
											12.493
										],
										[
											-14.975,
											0.01
										],
										[
											-8.288,
											-12.471
										],
										[
											-2.079,
											-14.82
										],
										[
											-0.01,
											-14.979
										],
										[
											14.975,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											10.148,
											0.716
										],
										[
											0.458,
											0
										],
										[
											1.552,
											-0.398
										],
										[
											0,
											-9.118
										],
										[
											-8.418,
											-2.151
										],
										[
											-1.671,
											0
										],
										[
											-0.438,
											0.02
										],
										[
											0,
											10.312
										]
									],
									"o": [
										[
											-0.458,
											-0.02
										],
										[
											-1.671,
											0
										],
										[
											-8.418,
											2.15
										],
										[
											0,
											9.097
										],
										[
											1.552,
											0.398
										],
										[
											0.458,
											0
										],
										[
											10.148,
											-0.697
										],
										[
											0,
											-10.332
										]
									],
									"v": [
										[
											1.364,
											-19.479
										],
										[
											-0.01,
											-19.52
										],
										[
											-4.865,
											-18.901
										],
										[
											-19.512,
											0.01
										],
										[
											-4.865,
											18.903
										],
										[
											-0.01,
											19.52
										],
										[
											1.344,
											19.479
										],
										[
											19.512,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-297.559,
													1062.121
												],
												[
													342.441,
													1062.121
												],
												[
													342.441,
													-33.879
												],
												[
													-297.559,
													-33.879
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-297.559,
													-33.879
												],
												[
													342.441,
													-33.879
												],
												[
													342.441,
													1062.121
												],
												[
													-297.559,
													1062.121
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									297.559,
									33.879
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 6,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.038,
											0
										],
										[
											0,
											-1.991
										],
										[
											-0.061,
											-0.264
										],
										[
											1.777,
											2.182
										],
										[
											0,
											-0.661
										],
										[
											-0.966,
											-0.646
										],
										[
											0.486,
											0.27
										],
										[
											0,
											0
										],
										[
											-1.649,
											-0.332
										],
										[
											0.33,
											0
										],
										[
											0.221,
											0.044
										],
										[
											-1.577,
											-0.029
										],
										[
											1.689,
											0
										],
										[
											0.282,
											0.032
										],
										[
											-2.036,
											0
										],
										[
											0,
											4.766
										],
										[
											0,
											0
										],
										[
											-0.482,
											0.724
										],
										[
											0.73,
											-0.087
										],
										[
											-0.27,
											0.84
										],
										[
											0.822,
											-0.162
										]
									],
									"o": [
										[
											-1.991,
											0
										],
										[
											0,
											0.282
										],
										[
											-2.996,
											-0.151
										],
										[
											-0.311,
											0.532
										],
										[
											0,
											1.251
										],
										[
											-0.59,
											-0.02
										],
										[
											0,
											0
										],
										[
											0,
											1.746
										],
										[
											-0.302,
											0.081
										],
										[
											-0.233,
											0
										],
										[
											0.459,
											1.434
										],
										[
											-1.233,
											0.967
										],
										[
											-0.291,
											0
										],
										[
											1.596,
											1.025
										],
										[
											6.633,
											0
										],
										[
											0,
											0
										],
										[
											0.709,
											-0.506
										],
										[
											-0.647,
											0.288
										],
										[
											0.745,
											-0.446
										],
										[
											-0.698,
											0.413
										],
										[
											-0.657,
											-0.702
										]
									],
									"v": [
										[
											3.38,
											-7.141
										],
										[
											-0.226,
											-3.535
										],
										[
											-0.133,
											-2.713
										],
										[
											-7.563,
											-6.482
										],
										[
											-8.051,
											-4.669
										],
										[
											-6.448,
											-1.667
										],
										[
											-8.081,
											-2.12
										],
										[
											-8.081,
											-2.075
										],
										[
											-5.189,
											1.462
										],
										[
											-6.139,
											1.588
										],
										[
											-6.818,
											1.521
										],
										[
											-3.451,
											4.026
										],
										[
											-7.928,
											5.567
										],
										[
											-8.788,
											5.518
										],
										[
											-3.262,
											7.141
										],
										[
											6.997,
											-3.121
										],
										[
											6.984,
											-3.588
										],
										[
											8.788,
											-5.452
										],
										[
											6.717,
											-4.883
										],
										[
											8.302,
											-6.877
										],
										[
											6.011,
											-6.002
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											4.034,
											-0.926
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.427,
											-0.022
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-0.202,
											2.917
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.419,
											0.065
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											4.944,
											-2.623
										],
										[
											-1.249,
											4.885
										],
										[
											2.311,
											2.095
										],
										[
											0.412,
											2.061
										],
										[
											3.701,
											1.175
										],
										[
											0.505,
											0.532
										],
										[
											-1.506,
											-0.812
										],
										[
											-0.235,
											-0.681
										],
										[
											2.463,
											-0.546
										],
										[
											2.058,
											-2.28
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.37,
											0.07
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.229,
											-0.281
										]
									],
									"v": [
										[
											3.084,
											-5.078
										],
										[
											2.161,
											-4.526
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-297.641,
													1062.11
												],
												[
													342.359,
													1062.11
												],
												[
													342.359,
													-33.89
												],
												[
													-297.641,
													-33.89
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-297.641,
													-33.89
												],
												[
													342.359,
													-33.89
												],
												[
													342.359,
													1062.11
												],
												[
													-297.641,
													1062.11
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									297.641,
									33.89
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 7,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.373,
											2.011
										],
										[
											1.67,
											0
										],
										[
											0.458,
											-0.04
										],
										[
											-0.974,
											-1.672
										],
										[
											-1.831,
											-1.254
										]
									],
									"o": [
										[
											-1.553,
											-0.398
										],
										[
											-0.478,
											0
										],
										[
											1.313,
											1.413
										],
										[
											2.289,
											0.299
										],
										[
											-0.896,
											-2.289
										]
									],
									"v": [
										[
											27.731,
											-18.912
										],
										[
											22.876,
											-19.529
										],
										[
											21.482,
											-19.469
										],
										[
											24.924,
											-14.831
										],
										[
											31.154,
											-12.462
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.458,
											0
										],
										[
											1.552,
											-0.398
										],
										[
											0.895,
											-2.269
										],
										[
											-2.269,
											0.299
										],
										[
											-1.294,
											1.433
										]
									],
									"o": [
										[
											-1.671,
											0
										],
										[
											-1.373,
											1.991
										],
										[
											1.831,
											-1.234
										],
										[
											0.975,
											-1.672
										],
										[
											-0.458,
											-0.02
										]
									],
									"v": [
										[
											-22.876,
											-19.529
										],
										[
											-27.731,
											-18.912
										],
										[
											-31.154,
											-12.482
										],
										[
											-24.945,
											-14.831
										],
										[
											-21.502,
											-19.489
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.995,
											1.672
										],
										[
											1.831,
											1.214
										],
										[
											-1.353,
											-1.991
										],
										[
											-1.671,
											0
										],
										[
											-0.438,
											0.02
										]
									],
									"o": [
										[
											-2.269,
											-0.299
										],
										[
											0.915,
											2.269
										],
										[
											1.552,
											0.398
										],
										[
											0.458,
											0
										],
										[
											-1.294,
											-1.433
										]
									],
									"v": [
										[
											-24.965,
											14.811
										],
										[
											-31.154,
											12.482
										],
										[
											-27.731,
											18.892
										],
										[
											-22.876,
											19.509
										],
										[
											-21.522,
											19.469
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.268,
											-0.299
										],
										[
											1.313,
											-1.413
										],
										[
											-0.458,
											0
										],
										[
											-1.553,
											0.398
										],
										[
											-0.896,
											2.289
										]
									],
									"o": [
										[
											-0.976,
											1.672
										],
										[
											0.458,
											0.04
										],
										[
											1.67,
											0
										],
										[
											1.373,
											-1.991
										],
										[
											-1.831,
											1.234
										]
									],
									"v": [
										[
											24.945,
											14.811
										],
										[
											21.502,
											19.449
										],
										[
											22.876,
											19.509
										],
										[
											27.731,
											18.892
										],
										[
											31.154,
											12.462
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 4,
							"ty": "sh",
							"ix": 5,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.178,
											0
										],
										[
											0.497,
											0.04
										],
										[
											1.313,
											0.339
										],
										[
											6.447,
											0
										],
										[
											4.816,
											3.564
										],
										[
											1.393,
											-0.099
										],
										[
											0,
											0
										],
										[
											0.538,
											0
										],
										[
											0.179,
											0.02
										],
										[
											-9.095,
											0
										],
										[
											-6.029,
											5.913
										]
									],
									"o": [
										[
											-0.578,
											0
										],
										[
											-1.373,
											-0.099
										],
										[
											-4.816,
											3.564
										],
										[
											-6.428,
											0
										],
										[
											-1.293,
											0.339
										],
										[
											0,
											0
										],
										[
											-0.517,
											0.02
										],
										[
											-0.179,
											0
										],
										[
											6.03,
											5.913
										],
										[
											9.114,
											0
										],
										[
											-0.179,
											0.02
										]
									],
									"v": [
										[
											22.876,
											24.048
										],
										[
											21.204,
											23.988
										],
										[
											17.164,
											23.351
										],
										[
											-0.01,
											29.025
										],
										[
											-17.165,
											23.371
										],
										[
											-21.204,
											24.008
										],
										[
											-21.304,
											24.008
										],
										[
											-22.876,
											24.048
										],
										[
											-23.393,
											24.028
										],
										[
											-0.01,
											33.564
										],
										[
											23.392,
											24.028
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 5,
							"ty": "sh",
							"ix": 6,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											9.114,
											0
										],
										[
											6.01,
											-5.892
										],
										[
											-0.179,
											0
										],
										[
											-0.517,
											-0.04
										],
										[
											0,
											0
										],
										[
											-1.293,
											-0.318
										],
										[
											-6.428,
											0
										],
										[
											-4.796,
											-3.563
										],
										[
											-1.353,
											0.099
										],
										[
											-0.598,
											0
										],
										[
											-0.179,
											-0.02
										]
									],
									"o": [
										[
											-9.114,
											0
										],
										[
											0.179,
											-0.02
										],
										[
											0.518,
											0
										],
										[
											0,
											0
										],
										[
											1.373,
											0.099
										],
										[
											4.796,
											-3.543
										],
										[
											6.428,
											0
										],
										[
											1.273,
											-0.319
										],
										[
											0.577,
											-0.04
										],
										[
											0.178,
											0
										],
										[
											-6.029,
											-5.892
										]
									],
									"v": [
										[
											-0.01,
											-33.564
										],
										[
											-23.393,
											-24.048
										],
										[
											-22.876,
											-24.068
										],
										[
											-21.304,
											-24.008
										],
										[
											-21.184,
											-24.008
										],
										[
											-17.165,
											-23.391
										],
										[
											-0.01,
											-29.025
										],
										[
											17.164,
											-23.371
										],
										[
											21.104,
											-23.988
										],
										[
											22.876,
											-24.068
										],
										[
											23.392,
											-24.048
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-320.425,
													1062.11
												],
												[
													319.575,
													1062.11
												],
												[
													319.575,
													-33.89
												],
												[
													-320.425,
													-33.89
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-320.425,
													-33.89
												],
												[
													319.575,
													-33.89
												],
												[
													319.575,
													1062.11
												],
												[
													-320.425,
													1062.11
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									320.425,
									33.89
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 10,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Point Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 0,
							"s": [
								20
							],
							"e": [
								20
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 36,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 42
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											3.783
										],
										[
											3.782,
											0
										],
										[
											0,
											-3.783
										],
										[
											-3.781,
											0
										]
									],
									"o": [
										[
											0,
											-3.783
										],
										[
											-3.781,
											0
										],
										[
											0,
											3.783
										],
										[
											3.782,
											0
										]
									],
									"v": [
										[
											6.429,
											-8.89
										],
										[
											-0.378,
											-15.699
										],
										[
											-7.185,
											-8.89
										],
										[
											-0.378,
											-2.081
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											6.052
										],
										[
											-6.427,
											0
										],
										[
											0,
											-6.431
										],
										[
											6.429,
											0
										]
									],
									"o": [
										[
											0,
											-6.052
										],
										[
											6.051,
											0
										],
										[
											0,
											6.052
										],
										[
											-6.427,
											0
										]
									],
									"v": [
										[
											-11.344,
											-8.89
										],
										[
											0,
											-20.238
										],
										[
											11.344,
											-8.89
										],
										[
											0,
											2.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											10.967,
											0
										],
										[
											0,
											-11.727
										],
										[
											0,
											0
										],
										[
											0,
											11.726
										]
									],
									"o": [
										[
											-11.343,
											0
										],
										[
											0,
											11.726
										],
										[
											0,
											0
										],
										[
											-0.378,
											-11.727
										]
									],
									"v": [
										[
											0,
											-29.316
										],
										[
											-20.419,
											-8.133
										],
										[
											0,
											27.046
										],
										[
											20.419,
											-8.133
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											6.805,
											-8.322
										],
										[
											0,
											0
										],
										[
											0,
											-1.135
										],
										[
											1.134,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.135
										],
										[
											-1.135,
											0
										],
										[
											0,
											0
										],
										[
											0,
											10.592
										],
										[
											-13.99,
											0
										],
										[
											0,
											-13.996
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											1.134,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											-1.135,
											0
										],
										[
											0,
											-1.135
										],
										[
											0,
											0
										],
										[
											-6.807,
											-8.7
										],
										[
											0,
											-13.996
										],
										[
											13.614,
											0
										],
										[
											-0.379,
											10.592
										]
									],
									"v": [
										[
											3.782,
											29.315
										],
										[
											13.614,
											29.315
										],
										[
											15.881,
											31.585
										],
										[
											13.614,
											33.855
										],
										[
											-13.612,
											33.855
										],
										[
											-15.882,
											31.585
										],
										[
											-13.612,
											29.315
										],
										[
											-3.781,
											29.315
										],
										[
											-24.957,
											-8.512
										],
										[
											0,
											-33.855
										],
										[
											24.958,
											-8.512
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-525.372,
													974.758
												],
												[
													114.628,
													974.758
												],
												[
													114.628,
													-121.242
												],
												[
													-525.372,
													-121.242
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-525.372,
													-121.242
												],
												[
													114.628,
													-121.242
												],
												[
													114.628,
													974.758
												],
												[
													-525.372,
													974.758
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									525.372,
									121.242
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 8,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Kart Blue Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						532,
						730,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						532,
						730,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833,
									0.833,
									0.833
								],
								"y": [
									0.833,
									0.833,
									0.833
								]
							},
							"o": {
								"x": [
									0.167,
									0.167,
									0.167
								],
								"y": [
									0.167,
									0.167,
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167",
								"0p833_0p833_0p167_0p167",
								"0p833_0p833_0p167_0p167"
							],
							"t": 0,
							"s": [
								0,
								0,
								100
							],
							"e": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									0.667,
									0.667,
									0.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									0.167,
									0.167,
									0.167
								],
								"y": [
									0.167,
									0.167,
									16.667
								]
							},
							"n": [
								"0p667_1_0p167_0p167",
								"0p667_1_0p167_0p167",
								"0p667_1_0p167_16p667"
							],
							"t": 65,
							"s": [
								0,
								0,
								100
							],
							"e": [
								100,
								100,
								100
							]
						},
						{
							"t": 75
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.972,
											0.243
										],
										[
											0.486,
											-1.945
										],
										[
											1.215,
											-0.244
										],
										[
											-0.486,
											1.946
										]
									],
									"o": [
										[
											1.944,
											-0.243
										],
										[
											-0.243,
											0.973
										],
										[
											-1.945,
											0.243
										],
										[
											0.244,
											-1.215
										]
									],
									"v": [
										[
											-0.486,
											-2.675
										],
										[
											2.674,
											0.486
										],
										[
											0.487,
											2.675
										],
										[
											-2.674,
											-0.487
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-538.459,
													348.59
												],
												[
													101.541,
													348.59
												],
												[
													101.541,
													-747.41
												],
												[
													-538.459,
													-747.41
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-538.459,
													-747.41
												],
												[
													101.541,
													-747.41
												],
												[
													101.541,
													348.59
												],
												[
													-538.459,
													348.59
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									538.459,
									747.41
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.215,
											0.243
										],
										[
											0.486,
											-1.945
										],
										[
											1.215,
											-0.244
										],
										[
											-0.486,
											1.946
										]
									],
									"o": [
										[
											1.944,
											-0.243
										],
										[
											-0.243,
											0.973
										],
										[
											-1.945,
											0.243
										],
										[
											0.244,
											-1.215
										]
									],
									"v": [
										[
											-0.486,
											-2.675
										],
										[
											2.674,
											0.486
										],
										[
											0.487,
											2.675
										],
										[
											-2.674,
											-0.487
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-524.847,
													348.59
												],
												[
													115.153,
													348.59
												],
												[
													115.153,
													-747.41
												],
												[
													-524.847,
													-747.41
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-524.847,
													-747.41
												],
												[
													115.153,
													-747.41
												],
												[
													115.153,
													348.59
												],
												[
													-524.847,
													348.59
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									524.847,
									747.41
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 4,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.679,
											-2.529
										],
										[
											0,
											0
										],
										[
											-1.8,
											0
										],
										[
											0,
											0
										],
										[
											-0.502,
											1.686
										],
										[
											0,
											0
										],
										[
											2.664,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.468,
											1.74
										],
										[
											0,
											0
										],
										[
											1.76,
											0
										],
										[
											0,
											0
										],
										[
											0.762,
											-2.553
										],
										[
											0,
											0
										],
										[
											-2.618,
											0
										]
									],
									"v": [
										[
											-11.608,
											-3.13
										],
										[
											-9.372,
											5.197
										],
										[
											-5.528,
											8.146
										],
										[
											5.226,
											8.146
										],
										[
											9.039,
											5.303
										],
										[
											11.525,
											-3.026
										],
										[
											7.711,
											-8.146
										],
										[
											-7.764,
											-8.146
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-532.941,
													365.245
												],
												[
													107.059,
													365.245
												],
												[
													107.059,
													-730.755
												],
												[
													-532.941,
													-730.755
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-532.941,
													-730.755
												],
												[
													107.059,
													-730.755
												],
												[
													107.059,
													365.245
												],
												[
													-532.941,
													365.245
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									532.941,
									730.755
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 4,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-0.243
										],
										[
											0,
											0.243
										],
										[
											0,
											0
										],
										[
											0.729,
											0
										],
										[
											0,
											0
										],
										[
											0.244,
											0.728
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.807,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.973
										],
										[
											-0.972,
											0
										],
										[
											0,
											0
										],
										[
											-0.243,
											-0.729
										],
										[
											0,
											0
										],
										[
											-1.792,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.243
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0.243
										],
										[
											0,
											0
										],
										[
											0,
											0.728
										],
										[
											0,
											0
										],
										[
											-0.729,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.46,
											-1.749
										],
										[
											0,
											0
										],
										[
											-0.729,
											0
										],
										[
											0,
											-0.729
										],
										[
											0,
											0
										],
										[
											0.729,
											0
										],
										[
											0,
											0
										],
										[
											0.475,
											1.728
										],
										[
											0,
											0
										],
										[
											0.243,
											0
										],
										[
											0,
											0
										],
										[
											0.242,
											0.73
										]
									],
									"v": [
										[
											21.632,
											-3.647
										],
										[
											21.632,
											-3.647
										],
										[
											16.285,
											15.076
										],
										[
											15.07,
											16.29
										],
										[
											-4.132,
											16.29
										],
										[
											-5.591,
											15.32
										],
										[
											-10.694,
											-4.133
										],
										[
											-12.345,
											-10.404
										],
										[
											-16.193,
											-13.372
										],
										[
											-20.174,
											-13.372
										],
										[
											-21.632,
											-14.831
										],
										[
											-20.174,
											-16.29
										],
										[
											-12.153,
											-16.29
										],
										[
											-10.694,
											-15.318
										],
										[
											-8.825,
											-8.518
										],
										[
											-4.987,
											-5.591
										],
										[
											20.66,
											-5.591
										],
										[
											21.147,
											-5.106
										],
										[
											21.39,
											-4.862
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-527.278,
													370.96
												],
												[
													112.722,
													370.96
												],
												[
													112.722,
													-725.04
												],
												[
													-527.278,
													-725.04
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-527.278,
													-725.04
												],
												[
													112.722,
													-725.04
												],
												[
													112.722,
													370.96
												],
												[
													-527.278,
													370.96
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									527.278,
									725.04
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 4,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-2.198,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.198
										],
										[
											0,
											0
										],
										[
											2.199,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.199
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											2.199,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.199
										],
										[
											0,
											0
										],
										[
											-2.198,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.198
										]
									],
									"v": [
										[
											-31.159,
											-33.023
										],
										[
											31.159,
											-33.023
										],
										[
											35.14,
											-29.043
										],
										[
											35.14,
											29.042
										],
										[
											31.159,
											33.023
										],
										[
											-31.159,
											33.023
										],
										[
											-35.139,
											29.042
										],
										[
											-35.139,
											-29.043
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-531.699,
													366.569
												],
												[
													108.301,
													366.569
												],
												[
													108.301,
													-729.431
												],
												[
													-531.699,
													-729.431
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-531.699,
													-729.431
												],
												[
													108.301,
													-729.431
												],
												[
													108.301,
													366.569
												],
												[
													-531.699,
													366.569
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.277999997606,
									0.556999954523,
									0.902000038297,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									531.699,
									729.431
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 4,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Devices Blue Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						408,
						938,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						408,
						938,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667,
									0.667,
									0.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									0.167,
									0.167,
									0.167
								],
								"y": [
									0,
									0,
									0
								]
							},
							"n": [
								"0p667_1_0p167_0",
								"0p667_1_0p167_0",
								"0p667_1_0p167_0"
							],
							"t": 0,
							"s": [
								0,
								0,
								100
							],
							"e": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									0.667,
									0.667,
									0.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									0.167,
									0.167,
									0.167
								],
								"y": [
									0.032,
									0.032,
									3.175
								]
							},
							"n": [
								"0p667_1_0p167_0p032",
								"0p667_1_0p167_0p032",
								"0p667_1_0p167_3p175"
							],
							"t": 73,
							"s": [
								0,
								0,
								100
							],
							"e": [
								100,
								100,
								100
							]
						},
						{
							"t": 85
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.123,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.124
										],
										[
											-2.123,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.123
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-2.123,
											0
										],
										[
											0,
											-2.123
										],
										[
											0,
											0
										],
										[
											2.123,
											0
										],
										[
											0,
											2.124
										]
									],
									"v": [
										[
											16.501,
											3.846
										],
										[
											-16.5,
											3.846
										],
										[
											-20.345,
											0
										],
										[
											-16.5,
											-3.846
										],
										[
											16.501,
											-3.846
										],
										[
											20.345,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-397.703,
													118.638
												],
												[
													242.297,
													118.638
												],
												[
													242.297,
													-977.362
												],
												[
													-397.703,
													-977.362
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-397.703,
													-977.362
												],
												[
													242.297,
													-977.362
												],
												[
													242.297,
													118.638
												],
												[
													-397.703,
													118.638
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									397.703,
									977.362
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											8.433,
											-4.428
										],
										[
											-8.433,
											-4.428
										],
										[
											-8.433,
											4.429
										],
										[
											8.433,
											4.429
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											4.366,
											0.363
										],
										[
											-4.367,
											0.363
										],
										[
											-4.367,
											-0.363
										],
										[
											4.366,
											-0.363
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-397.703,
													126.442
												],
												[
													242.297,
													126.442
												],
												[
													242.297,
													-969.558
												],
												[
													-397.703,
													-969.558
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-397.703,
													-969.558
												],
												[
													242.297,
													-969.558
												],
												[
													242.297,
													126.442
												],
												[
													-397.703,
													126.442
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									397.703,
									969.558
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 6,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-3.711
										],
										[
											0,
											0
										],
										[
											-3.744,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-3.744,
											0
										],
										[
											0,
											0
										],
										[
											0,
											3.711
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-41.761,
											-25.055
										],
										[
											-3.373,
											-25.055
										],
										[
											-3.373,
											-32.007
										],
										[
											-41.964,
											-32.007
										],
										[
											-48.71,
											-25.258
										],
										[
											-48.71,
											25.258
										],
										[
											-41.964,
											32.007
										],
										[
											30.46,
											32.007
										],
										[
											30.46,
											25.021
										],
										[
											-41.761,
											25.021
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											3.744,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-3.711
										]
									],
									"v": [
										[
											41.963,
											-32.007
										],
										[
											3.373,
											-32.007
										],
										[
											3.373,
											-25.055
										],
										[
											41.76,
											-25.055
										],
										[
											41.76,
											-10.411
										],
										[
											48.71,
											-10.411
										],
										[
											48.71,
											-25.258
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-399.164,
													161.866
												],
												[
													240.836,
													161.866
												],
												[
													240.836,
													-934.134
												],
												[
													-399.164,
													-934.134
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-399.164,
													-934.134
												],
												[
													240.836,
													-934.134
												],
												[
													240.836,
													161.866
												],
												[
													-399.164,
													161.866
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									399.164,
									934.134
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 6,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.429,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.464
										],
										[
											0,
											0
										],
										[
											-2.462,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.463
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-2.462,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.463
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.429,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.464
										]
									],
									"v": [
										[
											15.483,
											-32.107
										],
										[
											-15.45,
											-32.107
										],
										[
											-19.902,
											-27.654
										],
										[
											-19.902,
											27.654
										],
										[
											-15.45,
											32.107
										],
										[
											-3.373,
											32.107
										],
										[
											-3.373,
											25.359
										],
										[
											-13.156,
											25.359
										],
										[
											-13.156,
											-25.359
										],
										[
											13.156,
											-25.359
										],
										[
											13.156,
											25.359
										],
										[
											3.374,
											25.359
										],
										[
											3.374,
											32.107
										],
										[
											15.483,
											32.107
										],
										[
											19.902,
											27.654
										],
										[
											19.902,
											-27.654
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-442.78,
													146.918
												],
												[
													197.22,
													146.918
												],
												[
													197.22,
													-949.082
												],
												[
													-442.78,
													-949.082
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-442.78,
													-949.082
												],
												[
													197.22,
													-949.082
												],
												[
													197.22,
													146.918
												],
												[
													-442.78,
													146.918
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									442.78,
									949.082
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 4,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-1.322
										],
										[
											0,
											0
										],
										[
											1.146,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.322
										],
										[
											0,
											0
										],
										[
											-1.147,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											1.322
										],
										[
											0,
											0
										],
										[
											-1.147,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.322
										],
										[
											0,
											0
										],
										[
											1.146,
											0
										]
									],
									"v": [
										[
											75.261,
											-54.13
										],
										[
											75.261,
											54.132
										],
										[
											73.186,
											56.525
										],
										[
											-73.186,
											56.525
										],
										[
											-75.261,
											54.132
										],
										[
											-75.261,
											-54.13
										],
										[
											-73.186,
											-56.524
										],
										[
											73.186,
											-56.524
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-406.568,
													155.882
												],
												[
													233.432,
													155.882
												],
												[
													233.432,
													-940.118
												],
												[
													-406.568,
													-940.118
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-406.568,
													-940.118
												],
												[
													233.432,
													-940.118
												],
												[
													233.432,
													155.882
												],
												[
													-406.568,
													155.882
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.277999997606,
									0.556999954523,
									0.902000038297,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									406.568,
									940.118
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 4,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 2,
			"nm": "BG",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Bar Second Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						320,
						548,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											320,
											451
										],
										[
											320,
											639
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.277999997606,
									0.556999954523,
									0.902000038297,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"n": [
									"0p833_0p833_0p167_0p167"
								],
								"t": 0,
								"s": [
									20
								],
								"e": [
									20
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"n": [
									"0p833_0p833_0p167_0p167"
								],
								"t": 54,
								"s": [
									20
								],
								"e": [
									85
								]
							},
							{
								"t": 65
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/healthcare/animations/personalize/data.json
// module id = 1391
// module chunks = 0